import Page from "@/components/pages/inventory/customer/page";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/inventory/customer/_modal/")({
	component: Page,
});
